import { Trans, useTranslation } from 'react-i18next';
import { nsNewsletter } from '@/app/i18n/namespaces';

// Sprint number : 2627
const Sp2627Newsletter300626 = () => {
    const { t: translate } = useTranslation(nsNewsletter);
    const elements = { 1: <b /> };

    return (
        <div className='space-y-4'>
            <p className='font-semibold text-lg text-primary'>
                {translate('editions.sp2627.title')}
            </p>
            <p><Trans t={translate} i18nKey='editions.sp2627.intro' components={elements} /></p>
            <p><Trans t={translate} i18nKey='editions.sp2627.list_title' components={elements} /></p>
            <ul className='list-disc ml-8 space-y-2'>
                <li><Trans t={translate} i18nKey='editions.sp2627.list.item1' components={elements} /></li>
                <li><Trans t={translate} i18nKey='editions.sp2627.list.item2' components={elements} /></li>
                <li><Trans t={translate} i18nKey='editions.sp2627.list.item3' components={elements} /></li>
                <li><Trans t={translate} i18nKey='editions.sp2627.list.item4' components={elements} /></li>
                <li><Trans t={translate} i18nKey='editions.sp2627.list.item5' components={elements} /></li>
                <li><Trans t={translate} i18nKey='editions.sp2627.list.item6' components={elements} /></li>
                <li><Trans t={translate} i18nKey='editions.sp2627.list.item7' components={elements} /></li>
            </ul>
            <p><Trans t={translate} i18nKey='editions.sp2627.conclusion' components={elements} /></p>
        </div>
    );
};

export default Sp2627Newsletter300626;
